
import { defineComponent } from 'vue'
import Pagination from '@/components/shared/pagination/Pagination.vue'
import IPagination from '@/types/api/pagination.type'
import { UserListItem } from '@/types/core/user.type'
import { __GetUserListPayload } from '@/stores/result/action-dto'
import VButton from '@/components/shared/button/VButton.vue'
import TSortDictionary from '@/types/api/sort-dictionary.type'
import { ExcelMerchantListType } from '@/types/api/export-excel.type'

export default defineComponent({
  name: 'UserListTable',
  components: {
    VButton,
    Pagination,
  },
  props: {
    campaignCode: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      sortBy: null as 'RegisterDate' | null,
      sortDictionary: null as TSortDictionary,
      pagination: {
        page: 1,
        length: 10,
      } as Pick<IPagination, 'page' | 'length'>,
      arrow_down: require("@/assets/svgs/icons/sort/arrow_down.svg"),
      arrow_up: require("@/assets/svgs/icons/sort/arrow_up.svg"),
      arrow_null: require("@/assets/svgs/icons/sort/arrow.svg"),
    }
  },
  async mounted() {
    await this.getUserList()
  },
  computed: {
    firstIndexInPage(): number {
      return (this.pagination.page - 1) * this.pagination.length
    },
    userList(): Array<UserListItem> {
      return this.$store.getters['userList']
    },
    isLoadingUserList(): boolean {
      return this.$store.getters['isLoadingUserList']
    },
    isErrorLoadingUserList(): boolean {
      return this.$store.getters['isErrorLoadingUserList']
    },
    isNoUserList(): string | null {
      return this.$store.getters['isNoUserList']
    },
    paginationUserList(): IPagination {
      return this.$store.getters['paginationUserList']
    },
    sortIcon() {
      if (this.sortBy === 'RegisterDate') {
        return this.sortDictionary === 'ASC' ? 'arrow_up' : 'arrow_down'
      }
      return 'arrow_null'
    },
  },
  watch: {
    campaignCode: {
      deep: true,
      handler: async function (newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
          await this.getUserList()
        }
      },
    },
    isLoadingUserList: {
      deep: true,
      handler: function (newVal: string) {
        if (!newVal && !this.isErrorLoadingUserList) {
          this.pagination = {
            page: this.paginationUserList.page,
            length: this.paginationUserList.length,
          }
        }
      },
    },
  },
  methods: {
    async getUserList() {
      if (!this.campaignCode) return
      try {
        const getUserListPayload: __GetUserListPayload = {
          campaignCode: this.campaignCode,
          sortBy: this.sortBy,
          sortDictionary: this.sortDictionary,
          pagination: this.pagination,
        }
        await this.$store.dispatch('getUserList', getUserListPayload)
      } catch (error) {
        console.error('Error fetching user list:', error)
        throw error
      }
    },
    formatDate(dateString: string): string {
      return this.$dayjs(dateString).format('YYYY/MM/DD')
    },
    handlePageChange(nextPage: number) {
      if (nextPage < 1) {
        this.pagination.page = 1
      } else if (nextPage > this.paginationUserList.totalPages) {
        this.pagination.page = this.paginationUserList.totalPages
      } else {
        this.pagination.page = nextPage
      }
      this.getUserList()
    },
    handleSelectPageNumber(pageNumber: number) {
      this.pagination.page = pageNumber
      this.getUserList()
    },
    handlePageLengthChange(pageLength: number) {
      this.pagination.length = pageLength
      this.pagination.page = 1
      this.getUserList()
    },
    async DoExportExcel() {
      const payload = {
        campaignCode: this.campaignCode,
        sortBy: this.sortBy,
        sortDictionary: this.sortDictionary,
        pagination: {
          length: 100000,
          page: 1,
        },
        excelMerchantListType: ExcelMerchantListType.AffiliateExperience,
      }
      await this.$store.dispatch('getExcelUserList', payload);
    },
    sort() {
      this.sortBy = 'RegisterDate'

      switch (this.sortDictionary) {
        case 'DESC':
          this.sortDictionary = 'ASC'
          break;
        case 'ASC':
          this.sortBy = null
          this.sortDictionary = null
          break;
        default:
          this.sortDictionary = 'DESC'
      }
      this.getUserList()
    },
  },
})
